import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[550px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Group%20of%20diverse%20Chinese%20young%20friends%20enjoying%20outdoor%20social%20gathering%20in%20warm%20sunset%20light%2C%20natural%20park%20setting%20with%20trees%2C%20laughing%20and%20talking%20together%2C%20warm%20golden%20atmosphere%2C%20editorial%20lifestyle%20photography%20with%20soft%20natural%20tones%20and%20organic%20composition%2C%20wide%20cinematic%20shot&width=1800&height=1000&seq=hero-bg-main&orientation=landscape"
          alt="17c一起 - 志同道合的朋友欢聚一堂"
          title="17c一起社交平台 - 共享互动社区"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-6 leading-tight">
            相聚共享，连接你我他
          </h1>
          <p className="text-sm md:text-lg text-white/85 mb-10 max-w-xl mx-auto leading-relaxed">
            17c一起，汇聚志同道合伙伴的互动平台。<br className="hidden sm:block" />
            随时随地与朋友、同好一起行动、一起分享、一起成长。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/outdoor"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="bg-primary-500 text-background-50 px-8 py-3 rounded-full text-sm font-label whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer w-full sm:w-auto"
            >
              探索活动
            </Link>
            <Link
              to="/about"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="bg-background-50/15 text-white border border-white/30 px-8 py-3 rounded-full text-sm font-label whitespace-nowrap hover:bg-background-50/25 transition-colors cursor-pointer w-full sm:w-auto"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/40 rounded-full flex justify-center">
          <div className="w-1 h-2 bg-white/60 rounded-full mt-2 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}